import _ from 'lodash';

export const EMPTY_EDITS = {};
export const EMPTY_SENT_BACK = {};

export const omitKey = (map, index) => _.omit(map, [index]);
